import { render, staticRenderFns } from "./NewRelationModal.vue?vue&type=template&id=a3299ef6&scoped=true"
import script from "./NewRelationModal.vue?vue&type=script&lang=js"
export * from "./NewRelationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3299ef6",
  null
  
)

export default component.exports